import { useState } from 'react';
import { AdminListPageWrapper } from '../../AdminListPage';
import { AdminSearch } from '@platform/client';
import { DownloadResultsModal } from './DownloadResultsModal';
import { RepUserSearchForm } from './RepUserSearchForm';
import { RepUserResultsTable } from './RepUserResultsTable';
import { RepUserFilters } from './RepUserSearchForm';

export const RepUserSearchPage = () => {
  const [filters, setFilters] = useState<RepUserFilters>();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  return (
    <>
      {!filters && <RepUserSearchForm setFilters={setFilters} />}
      {filters && (
        <AdminListPageWrapper>
          <RepUserResultsTable
            filters={filters}
            setFilters={setFilters}
            setDownloadModalOpen={setDownloadModalOpen}
          />
        </AdminListPageWrapper>
      )}
      {downloadModalOpen && filters && (
        <DownloadResultsModal
          userType='rep'
          filters={filters}
          onClose={() => {
            setDownloadModalOpen(false);
          }}
          fetchFn={AdminSearch.useGetRepResultExportData}
        />
      )}
    </>
  );
};
